import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthToken } from '../model/keycloak.interface';

@Injectable({
  providedIn: 'root'
})
export class DeepLinkService {
  private paramsSubject = new Subject<string>();

  public params() {
    return this.paramsSubject.pipe(filter(str => !!str));
  }

  public getSSOParams($link) {
    const hasCode = this.containsCode($link?.fragment);
    if (!hasCode) {
      return;
    }
    const ssoParams =
      this.getQueryFragmentAsObject<AuthToken>($link.fragment) ||
      ({} as AuthToken);
    if (!ssoParams || !ssoParams.code) {
      return;
    }
    ssoParams.code = (ssoParams.code as string).split('#')[0];
    return ssoParams;
  }

  public getQueryFragmentAsObject<T>(url: string): T {
    return url
      ?.slice(url.indexOf('?') + 1)
      ?.split('&')
      .reduce((asObject, currentPair) => {
        const splitted = currentPair.split('=');
        asObject[splitted[0]] = decodeURIComponent(splitted[1]);
        return asObject;
      }, {} as T);
  }

  public containsCode(fragment: string) {
    if (!fragment) {
      return false;
    }
    return fragment.indexOf('code') > -1;
  }
}
